import { Resources } from './State'

export function Initial(): Resources {
  return {}
}
